import { render, staticRenderFns } from "./UploadSubtitle.vue?vue&type=template&id=cffd137c&"
import script from "./UploadSubtitle.vue?vue&type=script&lang=js&"
export * from "./UploadSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./UploadSubtitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cffd137c')) {
      api.createRecord('cffd137c', component.options)
    } else {
      api.reload('cffd137c', component.options)
    }
    module.hot.accept("./UploadSubtitle.vue?vue&type=template&id=cffd137c&", function () {
      api.rerender('cffd137c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/UploadSubtitle.vue"
export default component.exports